module.exports = __webpack_public_path__ + "img/racecourse-greyville-poly-400.8ae7ea51.svg";